module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-13.4b8f3831.jpg";